import { type FC } from 'react';

type Print24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Print24: FC<Print24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path d="M16 8V5H8V8H6V3H18V8H16ZM18 12.5C18.283 12.5 18.521 12.404 18.713 12.213C18.904 12.021 19 11.783 19 11.5C19 11.217 18.904 10.979 18.713 10.788C18.521 10.596 18.283 10.5 18 10.5C17.717 10.5 17.479 10.596 17.288 10.788C17.096 10.979 17 11.217 17 11.5C17 11.783 17.096 12.021 17.288 12.213C17.479 12.404 17.717 12.5 18 12.5ZM16 19V15H8V19H16ZM18 21H6V17H2V11C2 10.15 2.292 9.438 2.875 8.863C3.458 8.288 4.167 8 5 8H19C19.85 8 20.563 8.288 21.138 8.863C21.713 9.438 22 10.15 22 11V17H18V21ZM20 15V11C20 10.717 19.904 10.479 19.713 10.288C19.521 10.096 19.283 10 19 10H5C4.717 10 4.479 10.096 4.288 10.288C4.096 10.479 4 10.717 4 11V15H6V13H18V15H20Z" />
        </svg>
    );
};

export default Print24;
